// Receiving options passed from the scrollTrigger function
function addObserver(el, options) {
  // Check if `IntersectionObserver` is supported
  if (!('IntersectionObserver' in window)) {
    // Simple fallback
    // The animation will be called immediately so the scroll animation doesn't happen on unsupported browsers
    el.classList.add('in-view')

    // We don't need to execute the rest of the code
    return
  }

  // We are creating a new IntersectionObserver instance
  const observerInstance = new IntersectionObserver((entries, observer) => {
    // This takes a callback function that receives two arguments: the elements list and the observer instance.
    entries.forEach((entry) => {
      // `entry.isIntersecting` will be true if the element is visible
      if (entry.isIntersecting) {
        entry.target.classList.add('in-view')
        // We are removing the observer from the element after adding the in-view class
        observer.unobserve(entry.target)
      }
    })
  }, options) // Passing the options object to the observer

  // Adding the observer to the element
  observerInstance.observe(el)
}

// Receiving options as an object
// If the user doesn't pass any options, the default will be `{}`
function scrollTrigger(selector, options = {}) {
  // Multiple element can have same class/selector,
  // so we are using querySelectorAll
  let els = document.querySelectorAll(selector)

  // The above `querySelectorAll` returns a nodeList,
  // so we are converting it to an array
  els = Array.from(els)

  // Now we are iterating over the elements array
  els.forEach((el) => {
    // `addObserver function` attachs the IntersectionObserver to the element
    addObserver(el, options)
  })
}

// Fade in motion
export default document.addEventListener('DOMContentLoaded', () => {
  scrollTrigger('.fade-up')

  // A threshold of 0.65 means that when 65% of the target is visible within
  // the element specified by the root option, the callback is invoked.
  // The default is 0 (meaning as soon as even one pixel is visible, the
  // callback will be run)
  scrollTrigger('.fade-up-threshold', {
    threshold: 0.65,
  })

  scrollTrigger('.fade-left', {
    threshold: 0.65,
  })
})
